import styled from "styled-components";

export const DropzoneDiv = styled.div`
  border: 2px dashed #a9a9a9;
  border-radius: 5px;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 350px;
  img {
    height: 200px;
  }
`;
